var map = {
	"./chat-icon-bottom-nav-mobile-active.webp": 2696,
	"./chat-icon-bottom-nav-mobile.webp": 2697,
	"./home-icon-bottom-nav-mobile-active.webp": 2698,
	"./home-icon-bottom-nav-mobile-active_b.webp": 2699,
	"./home-icon-bottom-nav-mobile.webp": 2700,
	"./home-icon-bottom-nav-mobile_b.webp": 2701,
	"./me-icon-bottom-nav-mobile-active.webp": 2702,
	"./me-icon-bottom-nav-mobile.webp": 2703,
	"./promo-icon-bottom-nav-mobile-active.webp": 2704,
	"./promo-icon-bottom-nav-mobile.webp": 2705,
	"./sponsor-icon-bottom-nav-mobile-active.webp": 2706,
	"./sponsor-icon-bottom-nav-mobile.webp": 2707,
	"./stream-icon-bottom-nav-mobile-active.webp": 2708,
	"./stream-icon-bottom-nav-mobile.webp": 2709
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2695;